/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 */

import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonSize } from 'src/aero/aero-button/aero-button.component';
import { HttpService } from '../../http.service';

@Component({
  selector: 'bulb-create-new-link-dialog',
  templateUrl: './create-new-link-dialog.component.html',
  styleUrls: ['../partials/create-new-link-dialog.component.scss'],
  standalone: false,
})
export class CreateNewLinkDialogComponent {
  /**
 * Button size of content selection modal close button
 */
  public buttonSize: ButtonSize = ButtonSize.LARGE;

  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private http: HttpService,
    public config: DynamicDialogConfig,
  ) { }

  /**
   * close alert dialog
   */
  closeCreateNewLinkDialog(requestNewLink?: any): void {
    this.dynamicDialogRef.close(requestNewLink);
  }

  confirmCreateNewLink() {
    this.http.createNewShareableLink(this.config.data.unitId).subscribe((resp) => {
      this.closeCreateNewLinkDialog(resp);
    });
  }
}
